import Vue from "vue"
import store from "../index"

export default{
	state:{
		trx_restaurant: {
			cart: [],
			notes: '',
			promo_code: '',
      delivery:{
        isActive: false,
        savedAddressId: null,
        detail: {},
        courier: {}
      }
		},
		restaurant_customer:{
			name: '',
			email: '',
			phone_number: '',
		},
		restaurant_auth:{
			session: '',
			table_number: '',
			name: '',
			email: '',
			phone_number: '',
			type: '',
			lock_table_number: false
		},
		bill_payment:{
			customer_detail:{
        name: '',
        email: '',
        phone_number: '',
      }
		}
	},
	getters:{
		getRestaurantOrder: state => state.trx_restaurant,
		getRestaurantAuth: state => state.restaurant_auth,
		getRestaurantCustomerDetail: state => state.bill_payment.customer_detail,
		getRestaurantCustomer: state => state.restaurant_customer,
		getRestaurantDelivery: state => state.trx_restaurant.delivery,
		getRestaurantOrderQty: state => {
			let total = 0
			for(let cart of state.trx_restaurant.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						total += variant.qty
					}
				}else{
					total += cart.qty
				}
			}
			return total
		},
		getRestaurantOrderTotal(state){
			let total = 0
			for(let cart of state.trx_restaurant.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						total += calculateFinalPriceConcierge(variant.data.price) * variant.qty
					}
				}else{
					total += calculateFinalPriceConcierge(cart.product.data.price) * cart.qty
				}
			}

			return total
		},
		getRestaurantOrderTotalTaxServices(state){
			let total = 0
			for(let cart of state.trx_restaurant.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						total += (variant.data.price.tax_amount+variant.data.price.service_amount) * variant.qty
					}
				}else{
					total += (cart.product.data.price.tax_amount + cart.product.data.price.service_amount) * cart.qty
				}
			}

			return total
		},
		getRestaurantOrderTotalPromo(state){
			let total = 0
			for(let cart of state.trx_restaurant.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'DECREASE'){
							total += variant.data.price.promotion_amount * variant.qty
						}
					}
				}else{
					if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'DECREASE'){
						total += cart.product.data.price.promotion_amount * cart.qty
					}
				}
			}

			return total
		},
		getRestaurantOrderSubTotal(state){
			let total = 0
			for(let cart of state.trx_restaurant.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'INCREASE'){
							total += (variant.data.price.price_sell+variant.data.price.promotion_amount) * variant.qty
						}else{
							total += variant.data.price.price_sell * variant.qty
						}
					}
				}else{
					if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'INCREASE'){
						total += (cart.product.data.price.price_sell+cart.product.data.price.promotion_amount) * cart.qty
					}else{
						total += cart.product.data.price.price_sell * cart.qty
					}
				}
			}
			return total
		},
    getRestaurantDeliveryAvb(state){
      const isCartInvalid = !state.trx_restaurant.cart && state.trx_restaurant.cart.length === 0;
      if(isCartInvalid) return false;
      return state.trx_restaurant.cart.every(cartProduct=>{
        if(!cartProduct.product.is_variant) return Vue.prototype.$isProductAllowDelivery(cartProduct.product.data);
        return cartProduct.variant.every(cartVariant => Vue.prototype.$isProductAllowDelivery(cartVariant.data));
      })
    },
    getRestaurantDeliveryFee(state){
      const { detail = {}, courier = {} } = state.trx_restaurant.delivery
      if(Vue.prototype.$isEmpty(detail)) return 0;
      
      const isMerchantUseBiteship = store.getters.getMerchant.use_biteship;
      if(isMerchantUseBiteship){
        if(Vue.prototype.$isEmpty(courier)) return 0
        return courier.price;
      }else{
        return detail.delivery_fee;
      }
    }
	},
	mutations:{
		resetRestaurantOrder(state){
			state.trx_restaurant = {
				cart: [],
				notes: '',
				promo_code: ''
			}
		},
		setRestaurantAuth(state,payload='reset'){
			if(payload == 'reset'){
				state.restaurant_auth={
					session: '',
					table_number: '',
					name: '',
					email: '',
					phone_number: '',
					type: '',
					lock_table_number: false
				}
			}else{
				for (let param of payload){
					state.restaurant_auth[param.key] = param.value
				}
			}
		},
		setRestaurantOrderNotes(state,payload){
			state.trx_restaurant.notes = payload
		},
		setRestaurantOrder(state,payload){
			// find product in list
			let record_product = state.trx_restaurant.cart.findIndex(product=> product.product.data.id == payload.product.id)

			// if product not found
			if(record_product == -1){
				let is_variant = payload.product.variant_list.length > 0 ? true : false 
				let copied_data = JSON.parse(JSON.stringify(payload))
				delete copied_data.product.variant_list

				if(is_variant){
					delete copied_data.variant.tax_services
				}

				let data = {
					product: {
						data: copied_data.product,
						is_variant: is_variant
					},
					variant: !is_variant ? [] : [{
						data: copied_data.variant,
						qty: payload.qty,
						notes: ''
					}],
					notes: '',
					qty: payload.qty
				}

				state.trx_restaurant.cart.push(data)
			}else{
				if(state.trx_restaurant.cart[record_product].product.is_variant){
					// find variant in product list car
					let record_variant = state.trx_restaurant.cart[record_product].variant.findIndex(variant => variant.data.product_ga_pos_id == payload.variant.product_ga_pos_id)

					// if variant is matches instead product list
					if(record_variant != -1){

						state.trx_restaurant.cart[record_product].qty -= state.trx_restaurant.cart[record_product].variant[record_variant].qty

						state.trx_restaurant.cart[record_product].variant[record_variant].qty = payload.qty

						state.trx_restaurant.cart[record_product].qty += state.trx_restaurant.cart[record_product].variant[record_variant].qty
					}else{
						let copied_data_variant = JSON.parse(JSON.stringify(payload.variant))
						delete copied_data_variant.tax_services
						state.trx_restaurant.cart[record_product].variant.push({
							data: copied_data_variant,
							notes: '',
							qty: payload.qty
						})
						state.trx_restaurant.cart[record_product].qty += payload.qty
					}
				}else{
					state.trx_restaurant.cart[record_product].qty = payload.qty
				}	
			}
		},
		setRestaurantOrderNote(state,payload){
			let record_p = state.trx_restaurant.cart.findIndex(product=> product.product.data.id == payload.product_id)
			if(record_p == -1){
				console.log("ERROR WHILE ADDING NOTE : PRODUCT NOT FOUND")
			}else{
				if(payload.variant_id == ''){
					state.trx_restaurant.cart[record_p].notes = payload.notes
				}else{
					let record_v = state.trx_restaurant.cart[record_p].variant.findIndex(variant=> variant.data.id == payload.variant_id)
					if(record_v == -1){
						console.log("ERROR WHILE ADDING NOTE : VARIANT NOT FOUND")
					}else{
						state.trx_restaurant.cart[record_p].variant[record_v].notes = payload.notes
					}
				}
			}
		},
		setSpecificRestaurantOrder(state,payload){
			let cart_product = state.trx_restaurant.cart[payload.index_product]
			if(payload.is_variant){
				let cart_variant = cart_product.variant[payload.index_variant]
				if(cart_variant.data.promotion_affected.best == null || (cart_variant.data.promotion_affected.best != null && cart_variant.data.promotion_affected.best.promotion_type != "PROMO_CODE")){
					cart_variant.old_data = JSON.parse(JSON.stringify(cart_variant.data))
				}
				cart_variant.data = payload.data
			}else{
				if(cart_product.product.data.promotion_affected.best == null || (cart_product.product.data.promotion_affected.best != null && cart_product.product.data.promotion_affected.best.promotion_type != "PROMO_CODE")){
					cart_product.product.old_data = JSON.parse(JSON.stringify(cart_product.product.data))
				}
				cart_product.product.data = payload.data
			}
		},
		resetSpecificRestaurantOrder(state,payload){
			let cart_product = state.trx_restaurant.cart[payload.index_product]
			if(payload.is_variant){
				cart_product.variant[payload.index_variant].data = JSON.parse(JSON.stringify(cart_product.variant[payload.index_variant].old_data))
				delete cart_product.variant[payload.index_variant].old_data
			}else{
				cart_product.product.data = JSON.parse(JSON.stringify(cart_product.product.old_data))
				delete cart_product.product.old_data
			}
		},
		removeRestaurantOrder(state,payload){
			let record_product = state.trx_restaurant.cart.findIndex(product=> product.product.data.id == payload.product.id)
			if(record_product != -1){
				let is_variant = state.trx_restaurant.cart[record_product].product.is_variant
				if(is_variant){
					let record_variant = state.trx_restaurant.cart[record_product].variant.findIndex(variant => variant.data.product_ga_pos_id == payload.variant.product_ga_pos_id)
					if(record_variant != -1){
						let temp_variant = state.trx_restaurant.cart[record_product].variant[record_variant].qty
						state.trx_restaurant.cart[record_product].variant.splice(record_variant,1)
						if(state.trx_restaurant.cart[record_product].variant.length == 0){
							state.trx_restaurant.cart.splice(record_product,1)
						}else{
							state.trx_restaurant.cart[record_product].qty -= temp_variant
						}
					}
				}else{
					state.trx_restaurant.cart.splice(record_product,1)
				}
			}
		},
		setRestaurantOrderPromoCode(state,payload){
			state.trx_restaurant.promo_code = payload
		},
		setRestaurantCustomerDetail(state,payload){
      for (let param of payload){
        Vue.set(state.bill_payment.customer_detail,param.key,param.value)
			}
    },
		setRestaurantCustomer(state,payload){
      for (let param of payload){
        Vue.set(state.restaurant_customer,param.key,param.value)
			}
    },
		setRestaurantDeliveryActive(state,payload){
			state.trx_restaurant.delivery.isActive = payload
		},
    setRestaurantDeliverySavedAddressId(state,payload){
      state.trx_restaurant.delivery.savedAddressId = payload
    },
    setRestaurantDeliveryDetail(state,payload){
			state.trx_restaurant.delivery.detail = payload
		},
    setRestaurantDeliveryCourier(state,payload){
			state.trx_restaurant.delivery.courier = payload
		},
    checkAndResetRestaurantDelivery(state){
      const { delivery } = state.trx_restaurant;
      if (
        typeof delivery !== "object" ||
        delivery === null ||
        typeof delivery.isActive !== "boolean" ||
        (delivery.savedAddressId !== null && typeof delivery.savedAddressId !== "string") ||
        typeof delivery.detail !== "object" || 
        typeof delivery.courier !== "object" 
      ) {
        state.trx_restaurant.delivery = {
          isActive: false,
          savedAddressId: null,
          detail: {},
          courier: {}
        }
      }
    },
		resetRestaurantCustomerDetail(state){
			state.bill_payment = {
				customer_detail:{
					name: '',
					email: '',
					phone_number: '',
				}
			}
		},
		resetRestaurantCustomer(state){
			state.restaurant_customer = {
				name: '',
				email: '',
				phone_number: '',
			}
		},
		resetAllDataRestaurant(state){
			state.trx_restaurant = {
				cart: [],
				notes: '',
				promo_code: '',
				delivery:{
          isActive: false,
          savedAddressId: null,
          detail: {},
          courier: {}
        }
			}
			state.restaurant_auth ={
				session: '',
				table_number: '',
				name: '',
				email: '',
				phone_number: '',
				type: '',
				lock_table_number: false
			}
			state.restaurant_customer = {
				name: '',
				email: '',
				phone_number: '',
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/restaurant.js